import { FileText, Download, Link as LinkIcon, Calendar } from 'lucide-react';
import { getTaskCollectionsByYear } from '@/utils/documentPaths';
import { LK_URL } from '@/config/links';

export default function ParticipantsPage() {
  // Получаем сборники заданий по годам
  const taskCollections = getTaskCollectionsByYear();
  
  const resources = [
    {
      title: 'Документация конкурса',
      description: 'Официальный документ с правилами, критериями оценки, сроками и требованиями к участникам.',
      links: [
        {
          text: 'Положение о конкурсе 2026-2027 (PDF)',
          url: '/documents/regulation/polozhenie_2026-2027.pdf',
          icon: FileText,
        },
        //{
        //  text: 'Регламент проведения',
        //  url: '#', // TODO: Заменить на реальный путь, когда документ будет загружен
        //  icon: BookOpen,
        //},
      ],
    },
    {
      title: 'Материалы подготовки',
      description: 'Сборники заданий прошлых лет, методические рекомендации и обучающие материалы.',
      links: [
        // Динамически добавляем сборники заданий по годам
        ...taskCollections.map(collection => ({
          text: collection.title,
          url: collection.path,
          icon: Download,
        })),
       //{
       //   text: 'Видеоразборы заданий',
       //   url: '#',
       //   icon: LinkIcon,
       // },
       // {
       //   text: 'Методические рекомендации от экспертов',
       //   url: '#',
       //   icon: BookOpen,
       // },
      ],
    },
    {
      title: 'Полезные ссылки',
      description: 'Дополнительные ресурсы для подготовки и участия.',
      links: [
        {
          text: 'Официальная группа ВКонтакте',
          url: 'https://vk.com/o4ki.ircomp',
          icon: LinkIcon,
        },
        {
          text: 'MAX-чат поддержки',
          url: 'https://max.ru/join/jgM0K2Z4bv69V0W2y-mFAHJa5CfTIOlmkiyvsCvNgRY',
          icon: LinkIcon,
        },
        {
          text: 'Образовательная платформа',
          url: LK_URL,
          icon: LinkIcon,
        },
      ],
    },
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <div className="text-center mb-16">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Участникам</h1>
        <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
          Вся необходимая информация для подготовки и участия в онлайн-чемпионате Югры по креативным индустриям.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {resources.map((section, idx) => (
          <div
            key={idx}
            className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-3">{section.title}</h2>
            <p className="text-gray-600 mb-6">{section.description}</p>
            <div className="space-y-3">
              {section.links.map((link, linkIdx) => {
                // Определяем, является ли ссылка на PDF документ
                const isPdfDocument = link.url.endsWith('.pdf');
                const isExternalLink = link.url.startsWith('http') || link.url.startsWith('#');
                
                return (
                  <a
                    key={linkIdx}
                    href={link.url}
                    className="flex items-center space-x-3 p-3 rounded-lg border border-gray-200 hover:border-primary-500 hover:bg-primary-50 transition-colors group"
                    target={isPdfDocument || isExternalLink ? '_blank' : undefined}
                    rel={isPdfDocument || isExternalLink ? 'noopener noreferrer' : undefined}
                    // Для PDF файлов не используем download, чтобы открывать в браузере
                    download={!isPdfDocument && link.url.startsWith('/documents/') ? true : undefined}
                  >
                    <link.icon className="h-5 w-5 text-gray-500 group-hover:text-primary-600" />
                    <span className="text-gray-800 group-hover:text-primary-700 font-medium">
                      {link.text}
                    </span>
                  </a>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-16 bg-gradient-to-r from-primary-50 to-blue-50 rounded-2xl p-8 border border-primary-100">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Календарь чемпионата</h2>
        <p className="text-gray-700 mb-6">
          Следите за календарём событий, чтобы не пропустить ключевые этапы.
        </p>
        <ul className="space-y-4">
          <li className="flex items-start">
            <div className="bg-primary-100 text-primary-800 rounded-full p-2 mr-4">
              <Calendar className="h-5 w-5" />
            </div>
            <div>
              <h3 className="font-bold text-gray-900">Регистрация</h3>
              <p className="text-gray-600">до 30 октября 2026</p>
            </div>
          </li>
          <li className="flex items-start">
            <div className="bg-primary-100 text-primary-800 rounded-full p-2 mr-4">
              <Calendar className="h-5 w-5" />
            </div>
            <div>
              <h3 className="font-bold text-gray-900">Отборочный этап</h3>
              <p className="text-gray-600">31 октября – 2 ноября 2026</p>
            </div>
          </li>
          <li className="flex items-start">
            <div className="bg-primary-100 text-primary-800 rounded-full p-2 mr-4">
              <Calendar className="h-5 w-5" />
            </div>
            <div>
              <h3 className="font-bold text-gray-900">Финальный этап</h3>
              <p className="text-gray-600">29 ноября – 9 декабря 2026</p>
            </div>
          </li>
        </ul>
      </div>

      <div className="mt-16">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">Часто задаваемые вопросы</h2>
        <div className="space-y-4">
          <div className="border border-gray-200 rounded-xl p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Как зарегистрироваться?</h3>
            <p className="text-gray-600">
              Перейдите на страницу «Подать заявку», заполните форму.
            </p>
          </div>
          <div className="border border-gray-200 rounded-xl p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Где найти задания прошлых лет?</h3>
            <p className="text-gray-600">
              Все сборники заданий доступны в разделе «Материалы подготовки» выше. Вы можете скачать их бесплатно.
            </p>
          </div>
          <div className="border border-gray-200 rounded-xl p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Можно ли участвовать командой?</h3>
            <p className="text-gray-600">
              На отборочном этапе допускается только индивидуальное участие. На финальном этапе формируются команды по 3–5 человек.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}